(() => {
  "use strict";

  if (window.__ameliaEasifyGroupsInitialized) {
    return;
  }

  window.__ameliaEasifyGroupsInitialized = true;

  const EURUS_VARIANT_EVENT = "eurus:variant:change";
  const HIDDEN_CLASS = "amelia-easify-group-hidden";

  const GROUP_LABELS = {
    Paarringe: "Paarringe konfigurieren",
    Damenring: "Damenring konfigurieren",
    Herrenring: "Herrenring konfigurieren",
  };

  let activeRingType = null;
  let scheduledFrame = 0;

  /**
   * Fügt ausschließlich die benötigte Hilfsklasse hinzu.
   */
  function installStyles() {
    if (document.getElementById("amelia-easify-group-styles")) {
      return;
    }

    const style = document.createElement("style");

    style.id = "amelia-easify-group-styles";
    style.textContent = `
      .${HIDDEN_CLASS} {
        display: none !important;
      }
    `;

    document.head.append(style);
  }

  function normalizeText(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  /**
   * Findet die sichtbare Easify-Gruppenüberschrift
   * anhand ihres exakten Textes.
   */
  function findGroupLabel(labelText) {
    return Array.from(
      document.querySelectorAll(".po-label-label, label")
    ).find(
      (element) =>
        normalizeText(element.textContent) === labelText
    ) || null;
  }

  /**
   * Sucht vom Label aus den zugehörigen Gruppencontainer.
   *
   * Eine Optionsgruppe enthält weitere .po-option-root-
   * Elemente. Deshalb wird der erste passende übergeordnete
   * Container mit verschachtelten Optionen verwendet.
   */
  function findGroupRoot(label) {
    let element = label;

    while (element && element !== document.body) {
      if (
        element.matches?.(".po-option-root") &&
        element.querySelector?.(".po-option-root")
      ) {
        return element;
      }

      element = element.parentElement;
    }

    return label.closest(".po-option-root");
  }

  /**
   * Deaktiviert Eingabefelder ausgeblendeter Gruppen.
   * Dadurch gelangen deren Werte nicht als falsche
   * Positionseigenschaften in den Warenkorb.
   */
  function setControlsDisabled(groupRoot, disabled) {
    groupRoot
      .querySelectorAll(
        "input, select, textarea, button"
      )
      .forEach((control) => {
        if (disabled) {
          if (!control.disabled) {
            control.dataset.ameliaDisabledByGroup = "true";
            control.disabled = true;
          }

          return;
        }

        if (
          control.dataset.ameliaDisabledByGroup === "true"
        ) {
          control.disabled = false;
          delete control.dataset.ameliaDisabledByGroup;
        }
      });
  }

  function applyGroupVisibility(ringType) {
    if (!GROUP_LABELS[ringType]) {
      return false;
    }

    let foundGroups = 0;

    Object.entries(GROUP_LABELS).forEach(
      ([groupRingType, labelText]) => {
        const label = findGroupLabel(labelText);

        if (!label) {
          return;
        }

        const groupRoot = findGroupRoot(label);

        if (!groupRoot) {
          console.warn(
            "[Amelia] Easify-Gruppencontainer nicht gefunden:",
            labelText
          );

          return;
        }

        foundGroups += 1;

        const isActive =
          groupRingType === ringType;

        groupRoot.classList.toggle(
          HIDDEN_CLASS,
          !isActive
        );

        groupRoot.setAttribute(
          "aria-hidden",
          String(!isActive)
        );

        setControlsDisabled(
          groupRoot,
          !isActive
        );
      }
    );

    return foundGroups === 3;
  }

  /**
   * Easify kann seine Inhalte asynchron rendern.
   * Die Aktualisierung läuft deshalb im nächsten
   * Browser-Renderzyklus.
   */
  function scheduleGroupVisibility(ringType) {
    if (!GROUP_LABELS[ringType]) {
      return;
    }

    activeRingType = ringType;

    cancelAnimationFrame(scheduledFrame);

    scheduledFrame = requestAnimationFrame(() => {
      applyGroupVisibility(activeRingType);
    });
  }

  /**
   * Liest den anfänglich gewählten Ringtyp aus
   * dem echten Eurus-Variantenfeld.
   *
   * Funktioniert sowohl mit Buttons als auch Dropdown.
   */
  function getInitialRingType() {
    const checkedRadio = Array.from(
      document.querySelectorAll(
        'input[type="radio"]:checked'
      )
    ).find((radio) => GROUP_LABELS[radio.value]);

    if (checkedRadio) {
      return checkedRadio.value;
    }

    const matchingSelect = Array.from(
      document.querySelectorAll("select")
    ).find((select) => GROUP_LABELS[select.value]);

    return matchingSelect?.value || null;
  }

  /**
   * Das von dir nachgewiesene offizielle
   * Variantenereignis des Eurus-Themes.
   */
  document.addEventListener(
    EURUS_VARIANT_EVENT,
    (event) => {
      const variant = event.detail?.variant;

      const ringType =
        variant?.option1 ||
        variant?.title;

      scheduleGroupVisibility(ringType);
    }
  );

  /**
   * Reagiert darauf, wenn Easify seine Optionsfelder
   * später neu in den DOM einfügt.
   *
   * Nur childList wird beobachtet – dadurch entsteht
   * keine Schleife beim Ändern von Klassen oder disabled.
   */
  const observer = new MutationObserver(() => {
    if (!activeRingType) {
      activeRingType = getInitialRingType();
    }

    if (activeRingType) {
      scheduleGroupVisibility(activeRingType);
    }
  });

  function initialize() {
    installStyles();

    activeRingType = getInitialRingType();

    if (activeRingType) {
      scheduleGroupVisibility(activeRingType);
    }

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();